import Vue from 'vue'
import Vuetify from 'vuetify'
import VueRouter from 'vue-router'
import VueResource from 'vue-resource'
import VeeValidate, { Validator } from 'vee-validate'
import VueObserveVisibility from 'vue-observe-visibility'
import VueTouch from 'vue-touch'
import VueMoment from 'vue-moment'
import VueFullScreen from 'vue-fullscreen'
import VueCompositionApi from '@vue/composition-api'
import moment from 'moment-timezone'
import Meta from 'vue-meta'
import IdleJs from 'idle-js'

import App from './App.vue'
import store from './store/store'
import router from './router.js'
import api from '~/store/idonia-api/api'
import i18n from '~/i18n'
import services from '~/services.js'
import bus from '~/bus.js'
import { useBusUtils } from '~/commons/busUtils'
import { v4 as uuidv4 } from 'uuid'

import UploadFile from './components/common/UploadFile.vue'
import Uploader from '~/plugins/uploader'
import Avatar from '~/components/common/Avatar.vue'

import HTTPErrorView from '~/components/common/HTTPError.vue'

import IdoniaLocales from '~/locales'

import Logger from '~/plugins/logger/logger'
import useLanguageTree from '~/commons/language'
import { usePayloadFiller } from '~/commons/payloadFiller'
const { setFiller } = usePayloadFiller()
setFiller()
const {t} = useLanguageTree()
const { emitRoundTripEvent } = useBusUtils()
let app = null

// console.log('%c                                                ', 'font-size:100px; background: #46A9D4 url(https://idonia.com/static/theme/header-logo.png) no-repeat center;')

const loader = document.getElementById('welcome-loader-progress')
let progress = 10

export function readFile (file, callback, errorCallback) {
  const rawFile = new XMLHttpRequest()
  rawFile.overrideMimeType('application/json')
  rawFile.open('GET', file, true)
  rawFile.onreadystatechange = () => {
    if (rawFile.readyState === 4) {
      if (rawFile.status === 200) {
        callback(rawFile.responseText)
      } else {
        if (typeof errorCallback === 'function') {
          errorCallback(rawFile)
        }
      }
    }
  }
  rawFile.send(null)
}

function refreshProgress () {
  if (progress > 100) {
    loader.style.width = '100%'
  } else {
    loader.style.width = progress + '%'
  }
}

function parseURL (urlString, original) {
  try {
    // eslint-disable-next-line no-new
    new URL(urlString)
    return urlString
  } catch (error) {
    console.debug('catch', original, error)
    if (original) {
      return original
    }
    return parseURL(`https://${urlString}`, urlString)
  }
}

// region Version
const version = require('../version').default
Vue.prototype.$version = version
console.log('version', version)
// endregion

const hash = '?_=' + Date.now()

;(async () => {
  let promises = []

  Vue.use(VueObserveVisibility)
  Vue.use(VueRouter)
  Vue.use(VueResource)
  Vue.use(Uploader)
  Vue.use(VueTouch)
  Vue.use(Logger, {level: 8, replace: true})
  Vue.use(Meta)
  Vue.use(VueMoment, {moment})
  Vue.use(VueFullScreen)
  Vue.use(VueCompositionApi)

  Vue.component('http-error', HTTPErrorView)
  Vue.component('upload-file', UploadFile)
  Vue.component('avatar', Avatar)

  Vue.prototype.$services = services
  Vue.prototype.$tf = t
  window.addEventListener('DOMContentLoaded', function () {
    window.onerror = function (event) {
      Vue.$log.error(event)
    }
  })
  // region Checking Domain
  const UIDomain = window.location.hostname
  let auth = null
  if (window.location.hash && !window.location.pathname.includes('/v/')) { // TODO review when magicLink through id_token?
    auth = {}
    let authItems = window.location.hash.substr(1).split('&')
    for (let i = 0; i < authItems.length; i++) {
      let tmp = authItems[i].split('=')
      auth[tmp[0]] = tmp[1]
    }
    history.replaceState('', document.title, window.location.origin + window.location.pathname + window.location.search)
  }
  // endregion

  const params = new URLSearchParams(location.search)
  const WL = params.get('wl')
  const skipCookies = params.get('last_cookies_consent_already_signed') === 'true'
  const copyToken = params.get('copy_token')
  const copyAlert = params.get('copy_alert')
  const url = new URL(window.location.href)
  for (let key of ['wl', 'token', 'account_id', 'last_cookies_consent_already_signed', 'copy_token', 'copy_alert']) {
    url.searchParams.delete(key)
  }
  window.history.replaceState(null, null, url)
  if (copyAlert) {
    store.dispatch('session/setCopyAlert', copyAlert)
  }
  if (copyToken) {
    store.dispatch('session/setCopyToken', copyToken)
  }
  if (WL) {
    window.location = parseURL(WL) // window.location.protocol + '//' + WL + '.' + UIDomain
  }
  let urlParams = new URLSearchParams(window.location.search)
  // region Main Config
  let locale = ''
  let wlURL = 'https://whitelabel.idonia.com/'
  let config = require('./config.js')
  wlURL = config.whitelabelUrl || wlURL
  let provisionedConfig = {}
  let whitelabelConfig = {}
  let configPriorityPromise = new Promise(resolve => {
    readFile('/provisioning/config.json' + hash, response => {
      provisionedConfig = JSON.parse(response)
      resolve()
    }, (e) => {
      console.error(e)
      resolve()
    })
  }).then(() => {
    return new Promise((resolve) => {
      wlURL = provisionedConfig.whitelabelUrl || wlURL
      readFile(wlURL + UIDomain + '/config.json' + hash, response => {
        whitelabelConfig = JSON.parse(response)
        resolve()
      }
        , (e) => {
          console.error(e)
          resolve()
        })
    }).catch(e => {
      console.error(e)
    })
  }).catch(e => {
    console.error(e)
  }).finally(() => {
    config = Object.assign(config, provisionedConfig, whitelabelConfig)
    if (whitelabelConfig.gaTrackingCode && whitelabelConfig.gaTrackingCode !== provisionedConfig.gaTrackingCode && !whitelabelConfig.gtmCode) {
      config.gtmCode = ''
    }
  })
  await configPriorityPromise
// GET WHITELABEL UICONFIG ..............................................
  let whitelabelUIConfig = {}
  await new Promise((resolve) => {
    wlURL = provisionedConfig.whitelabelUrl || wlURL
    readFile(wlURL + UIDomain + '/config_ui.json' + hash, response => {
      whitelabelUIConfig = JSON.parse(response)
      resolve()
    }
    , (e) => {
      console.error(e)
      resolve()
    })
  }).catch(e => {
    console.error(e)
  })
// .....................................................................
  let configPromise = new Promise(resolve => {
    if (!window.__PRERENDER_INJECTED || !window.__PRERENDER_INJECTED.prerender) {
      if (config.enforceNoWWW && window.location.host.startsWith('www.')) {
        window.location = window.location.href.replace('www.', '')
      }
      if (config.enforceSSL && window.location.protocol === 'http:') {
        window.location = window.location.href.replace('http:', 'https:')
      }
    }
    if (config.skipGuestTour) {
      store.dispatch('session/skipGuestTour', true)
    }
    const baseImage = new Image()
    baseImage.src = '/static/theme/launcher-icon-4x.png' + hash

    const image = new Image()
    image.onload = () => {
      if (document.getElementById('welcome-logo')) {
        document.getElementById('welcome-logo').children[0].src = image.src
      }
    }
    image.onerror = () => {
      image.src = baseImage.src
    }
    image.src = config.whitelabelUrl + UIDomain + '/static/theme/launcher-icon-4x.png' + hash

    const faviconUrl = config.whitelabelUrl + UIDomain + '/asset/favicon'
    var oldLink = document.getElementById('favicon-logo')
    const faviconImage = new Image()
    faviconImage.onload = () => {
      var link = document.createElement('link')
      link.id = 'favicon-custom'
      link.rel = 'icon'
      link.href = faviconUrl
      document.head.removeChild(oldLink)
      document.head.appendChild(link)
    }
    faviconImage.src = faviconUrl
    config.defaultWLAfterCopy = config.defaultWLAfterCopy || 'https://mi.salud.es/'

    const defaultML = config.defaultMagicLinkURL || ''
    if (!defaultML || !defaultML.startsWith('/')) {
      config.defaultMagicLinkURL = (defaultML) ? `/v/${defaultML}` : '/v'
    }

    Vue.prototype.$config = config
    let loginMethods = urlParams.get('default_login_methods')
    let registerMethods = urlParams.get('default_register_methods')
    Vue.prototype.$whitelabel = {
      url: '',
      domain: '',
      loginMethods: loginMethods ? loginMethods.split(' ') : config.loginMethods || [],
      registerMethods: registerMethods ? registerMethods.split(' ') : config.registerMethods || []
    }
    let params = new URLSearchParams(window.location.search.slice(1))
    params.delete('default_login_methods')
    params.delete('default_register_methods')
    window.history.replaceState(null, null, window.location.pathname + '?' + params.toString() + window.location.hash)

    Vue.prototype.$whitelabel.domain = UIDomain
    Vue.prototype.$whitelabel.url = wlURL + UIDomain
    Vue.prototype.$whitelabel.baseURL = wlURL
    if (whitelabelUIConfig.index_config) {
      Vue.prototype.$whitelabel.indexConfig = whitelabelUIConfig.index_config
    }
    Vue.prototype.$whitelabel.htmlElements = (whitelabelUIConfig.html_elements || []).map((e) => {
      e.creationID = `inject-html-${uuidv4()}`
      return e
    })
    Vue.prototype.$whitelabel.downloadDisabled = whitelabelUIConfig.download_disabled || false
    Vue.prototype.$whitelabel.showAskForResults = whitelabelUIConfig.show_ask_for_results || false
    Vue.prototype.$whitelabel.showCopyAction = whitelabelUIConfig.show_copy_action || false
    Vue.prototype.$whitelabel.showFeedback = whitelabelUIConfig.show_feedback || false
    Vue.prototype.$whitelabel.viewerConfig = whitelabelUIConfig.viewer_config || {}
    Vue.prototype.$whitelabel.htmlElements = whitelabelUIConfig.html_elements || []

    const emptyIconImage = new Image()
    emptyIconImage.onload = () => {
      Vue.prototype.$whitelabel.existExternalEmptyIcon = true
    }
    emptyIconImage.src = wlURL + UIDomain + '/asset/empty-box-icon.png'

    progress += 14
    refreshProgress()
    resolve()
  }).then(async () => {
    let configPromises = []

    locale = config.lang || IdoniaLocales.defaultLocale.code

    api.config.apiUrl = config.apiUrl
    api.config.wsUrl = config.wsUrl
    api.config.ssoUrl = config.ssoUrl
    api.config.authUrl = config.authUrl

    await store.dispatch('session/getCSRFToken')
    configPromises.push(store.dispatch('contracts/init').catch(() => {}))
    configPromises.push(store.dispatch('viewport/update').catch(() => {}))
    // region Session
    let idToken = null
    if (auth && auth.id_token) {
      idToken = auth.id_token
      await store.dispatch('session/destroySession', auth).catch((e) => {
        console.error(e)
      })
    }
    configPromises.push(new Promise(resolve => {
      store.dispatch('session/checkSession', idToken).then(() => {
        resolve()
      })
        .catch((e) => {
          console.error(e)
          resolve()
        })
    }))

    // endregion

    // region Logging
    // configPromises.push(new Promise(resolve => {
    //   if (config.stackdriverApiKey) {
    //     window.addEventListener('DOMContentLoaded', function () {
    //       // eslint-disable-next-line no-undef
    //       let errorHandler = new StackdriverErrorReporter()
    //       errorHandler.start({
    //         key: config.stackdriverApiKey,
    //         projectId: 'idonia-common',
    //         service: 'idonia-ui:' + config.projectId,
    //         version: version.version + ':' + version.compilation
    //       })
    //     })
    //   }
    //
    //   progress += 14
    //   refreshProgress()
    //
    //   resolve()
    // }))
    // endregion

    // region i18n

    configPromises.push(new Promise(resolve => {
      IdoniaLocales.locales.forEach(item => {
        Validator.localize(item.code, require('vee-validate/dist/locale/' + item.code.slice(0, 2)))
      })

      let hl = urlParams.get('hl')
      if (hl) { // SET TO MAX PRIORITY hl ?
        locale = (IdoniaLocales.parseLocale(hl) || IdoniaLocales.parseLocale(locale) || IdoniaLocales.defaultLocale).code
        store.dispatch('session/locale', locale)
      }

      const validateLocale = config.lang.slice(0, 2)

      Validator.localize(validateLocale)
      Vue.use(VeeValidate)

      progress += 14
      refreshProgress()

      resolve()
    }).catch(e => {
      console.error(e)
    }))
    // endregion

    await Promise.all(configPromises).then(async () => {
      await store.dispatch('session/loadFromCookie', skipCookies)
        .then(() => {
          store.dispatch('notifications/setWebsocket', {socket: api.websocket()})
          store.dispatch('notifications/getNotifications')

          progress += 14
          refreshProgress()
        })
        .catch((e) => {
          console.error(e)
          // store.dispatch('session/destroySession')
        })
      locale = store.state.session.locale
      i18n.locale = locale

      api.config.initializing = false
      promises.push(new Promise(resolve => {
        store.dispatch('session/checkClient').then(() => {
          resolve()
        })
          .catch((e) => {
            console.error(e)
            resolve()
          })
      }))
    }).catch(e => {
      console.error(e)
    })
  }).catch(e => {
    console.error(e)
  })

  promises.push(configPromise)
  // endregion

  // region Theme
  let theme = require('./theme')

  promises.push(new Promise(resolve => {
    let provisionedTheme = {}
    let whitelabelTheme = {}
    const provisioningPromise = new Promise(resolve => {
      readFile('/provisioning/theme.json' + hash, response => {
        provisionedTheme = JSON.parse(response)
        resolve()
      }, resolve)
    }).catch(e => {
      console.error(e)
    })
    const whitelabelPromise = new Promise(resolve => {
      readFile(config.whitelabelUrl + UIDomain + '/theme.json' + hash, response => {
        whitelabelTheme = JSON.parse(response)
        resolve()
      }, resolve)
    }).catch(e => {
      console.error(e)
    })
    Promise.all([provisioningPromise, whitelabelPromise]).then(() => {
      theme = Object.assign(theme, provisionedTheme, whitelabelTheme)
      resolve()
    }).catch(e => {
      console.error(e)
    })
  }).then(() => {
    theme.options = theme.options || {}

    Vue.prototype.$theme = theme

    progress += 14
    refreshProgress()

    Vue.use(Vuetify, theme)
  }).catch(e => {
    console.error(e)
  }))
  // endregion

  // region Marketing
  let marketing = require('./marketing')

  promises.push(new Promise(resolve => {
    let provisionedMarketing = {}
    let whitelabelMarketing = {}
    const provisioningPromise = new Promise(resolve => {
      readFile('/provisioning/marketing.json' + hash, response => {
        provisionedMarketing = JSON.parse(response)
        resolve()
      }, resolve)
    }).catch(e => {
      console.error(e)
    })
    const whitelabelPromise = new Promise(resolve => {
      readFile(config.whitelabelUrl + UIDomain + '/marketing.json' + hash, response => {
        whitelabelMarketing = JSON.parse(response)
        resolve()
      }, resolve)
    }).catch(e => {
      console.error(e)
    })
    Promise.all([provisioningPromise, whitelabelPromise]).then(() => {
      marketing = Object.assign(marketing, provisionedMarketing, whitelabelMarketing)
      resolve()
    }).catch(e => {
      console.error(e)
    })
  }).then(() => {
    Vue.prototype.$marketing = marketing

    progress += 14
    refreshProgress()
  }).catch(e => {
    console.error(e)
  }))
  // endregion

  // region Environment
  const machine = require('./machine')
  Vue.prototype.$machine = machine
  // endregion

  await Promise.all(promises).catch(e => {
    console.error(e)
  })
  const expireSessionTime = parseInt(Vue.prototype.$config.expireSessionTime, 10)
  if (!isNaN(expireSessionTime) && expireSessionTime > 0) {
    store.dispatch('session/timeoutCookieExpiration', expireSessionTime)
    const idle = new IdleJs({
      idle: expireSessionTime * 1000,
      events: ['mousemove', 'keydown', 'mousedown', 'touchstart'],
      onIdle: function () {
        const idlePromises = []

        idlePromises.push(emitRoundTripEvent(bus, 'check-upload-idleness').then(() => {}))
        idlePromises.push(emitRoundTripEvent(bus, 'check-download-idleness').then(() => {}))

        Promise.all(idlePromises).then(() => {
          if (idle.idle) {
            bus.$emit('expire-session')
          }
        })
      },
      onActive: function () {
        bus.$emit('continue-session')
      },
      keepTracking: true,
      startAtIdle: true
    })
    Vue.prototype.$idle = idle
    idle.start()
    document.addEventListener('scroll', idle.idlenessEventsHandler, true)

    let lastRefreshTime = 0
    let idleBackendOnActive = function () {
      const now = Date.now()
      const expireSessionTimeMS = expireSessionTime * 1000
      const refreshRateMilliseconds = Math.max(60000, expireSessionTimeMS * 0.1)
      if (now - lastRefreshTime >= refreshRateMilliseconds) {
        lastRefreshTime = now
        store.dispatch('session/timeoutCookieExpiration', expireSessionTime + dialogExpireSessionDuration)
      }
    }
    const idleBackend = new IdleJs({
      idle: 1000, // 1000 ms
      events: ['mousemove', 'keydown', 'mousedown', 'touchstart'],
      onActive: idleBackendOnActive,
      keepTracking: true,
      startAtIdle: false
    })
    Vue.prototype.$idleBackendOnActive = idleBackendOnActive
    idleBackend.start()
  }

  progress = 100
  refreshProgress()

  app = new Vue({
    el: '#app',
    i18n,
    router,
    store,
    render (h) {
      return h(App)
    }
  })

  app.$moment.locale(locale.slice(0, 2))

  window.Idonia = app
})()

export default app
export const dialogExpireSessionDuration = 20
export function resetSessionInactivity () {
  Vue.prototype.$idle.reset()
  Vue.prototype.$idleBackendOnActive()
}



// WEBPACK FOOTER //
// ./src/main.js